import { IntroVideoType } from "./model";
export const videoUrl = introVideo => introVideo.type === IntroVideoType.VideoLink ? introVideo.videoLink.url : null;